module.exports = __webpack_public_path__ + "static/media/bm.c5d23b6a.svg";